export const AREA_PICKER_MODAL_ID = 'area-picker-modal';
